var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEntertainment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1097",
    "data-name": "Rectangle 1097",
    width: 35.671,
    height: 35.671,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_entertainment",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(335.998 222.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213-2",
    "data-name": "Group 213",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21862",
    "data-name": "Path 21862",
    d: "M.236,17.234a17,17,0,1,1,17,17,17,17,0,0,1-17-17",
    transform: "translate(0.601 0.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21863",
    "data-name": "Path 21863",
    d: "M1.257,14.632A13.373,13.373,0,1,1,14.632,28.007,13.375,13.375,0,0,1,1.257,14.632",
    transform: "translate(3.204 3.203)",
    fill: "#4ac2c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21864",
    "data-name": "Path 21864",
    d: "M11.938,25.31a13.362,13.362,0,0,0,9.273-23l-18.9,18.9a13.329,13.329,0,0,0,9.624,4.1",
    transform: "translate(5.898 5.9)",
    fill: "#6beaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21865",
    "data-name": "Path 21865",
    d: "M4.012,7.61a3.6,3.6,0,1,1,3.6,3.6,3.6,3.6,0,0,1-3.6-3.6",
    transform: "translate(10.225 10.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21866",
    "data-name": "Path 21866",
    d: "M2.175,13.41c-.032-.326-.05-.657-.05-.99A10.3,10.3,0,0,1,12.42,2.125a9.674,9.674,0,0,1,1.171.071l-.2,1.728a7.892,7.892,0,0,0-.972-.06A8.563,8.563,0,0,0,3.864,12.42a7.944,7.944,0,0,0,.043.823Z",
    transform: "translate(5.416 5.416)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21867",
    "data-name": "Path 21867",
    d: "M6.188,16.618A10.131,10.131,0,0,1,4.57,16.48l.266-1.718a8.891,8.891,0,0,0,1.352.117,8.565,8.565,0,0,0,8.556-8.556,8.819,8.819,0,0,0-.138-1.5l1.71-.3a10.212,10.212,0,0,1,.167,1.806A10.3,10.3,0,0,1,6.188,16.618",
    transform: "translate(11.647 11.512)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21868",
    "data-name": "Path 21868",
    d: "M5.673,19.694c-.3,0-.6-.014-.9-.032l.106-1.735c.263.014.529.028.795.028A12.168,12.168,0,0,0,17.828,5.8c0-.319-.014-.635-.039-.947l1.735-.131c.025.358.043.713.043,1.079A13.908,13.908,0,0,1,5.673,19.694",
    transform: "translate(12.162 12.034)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21869",
    "data-name": "Path 21869",
    d: "M1.118,15.3,1.111,15A13.908,13.908,0,0,1,15,1.111c.117,0,.234,0,.348.007l.117,0-.05,1.739-.124,0c-.1,0-.192-.007-.291-.007A12.17,12.17,0,0,0,2.85,15l.007.263Z",
    transform: "translate(2.832 2.831)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21870",
    "data-name": "Path 21870",
    d: "M17.836,35.671A17.836,17.836,0,1,1,35.671,17.836,17.857,17.857,0,0,1,17.836,35.671m0-33.932a16.1,16.1,0,1,0,16.1,16.1,16.116,16.116,0,0,0-16.1-16.1",
    transform: "translate(0 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21871",
    "data-name": "Path 21871",
    d: "M8.235,12.7A4.468,4.468,0,1,1,12.7,8.235,4.474,4.474,0,0,1,8.235,12.7m0-7.2a2.729,2.729,0,1,0,2.729,2.729A2.732,2.732,0,0,0,8.235,5.506",
    transform: "translate(9.601 9.6)",
    fill: "#404040"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEntertainment);
export default __webpack_public_path__ + "static/media/ic_entertainment.a1005438326442d2799442e4873a23bf.svg";
export { ForwardRef as ReactComponent };